export default {"src":"/_next/static/media/fastify.af94c3f5.svg","height":165,"width":256,"blurWidth":0,"blurHeight":0};